var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.122,
    height: 26.122,
    viewBox: "0 0 26.122 26.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-54.13 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3998",
    "data-name": "Path 3998",
    d: "M109.94,69.933a.975.975,0,0,1-.724-.325L100.1,59.5a.975.975,0,0,1,.724-1.624h3.651v-8.9a.975.975,0,0,1,.975-.975h8.987a.975.975,0,0,1,.975.975V57.87h3.649a.975.975,0,0,1,.724,1.624l-9.119,10.117A.975.975,0,0,1,109.94,69.933Zm-6.927-10.114L109.94,67.5l6.927-7.684h-2.433a.975.975,0,0,1-.975-.975V49.949h-7.037v8.895a.975.975,0,0,1-.975.975Z",
    transform: "translate(-42.749)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    "data-name": "Path 3999",
    d: "M76.009,339.237H58.373a4.248,4.248,0,0,1-4.243-4.242v-2.48a.975.975,0,0,1,1.949,0v2.48a2.3,2.3,0,0,0,2.294,2.293H76.009a2.3,2.3,0,0,0,2.293-2.293v-2.48a.975.975,0,0,1,1.949,0v2.48A4.248,4.248,0,0,1,76.009,339.237Z",
    transform: "translate(0 -265.116)",
    fill: "#474747"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.eec962c3510a0d3cb8cbcb5a2311f6fc.svg";
export { ForwardRef as ReactComponent };